// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "\n.resizable[data-v-cb8fe668] {\r\n\toverflow: hidden;\n}\n.anchor[data-v-cb8fe668] {\r\n\twidth: 12px;\r\n\theight: 10px;\r\n\tbackground-color: white;\r\n\tposition: absolute;\r\n\tright: 0;\r\n\tbottom: 0;\r\n\tcursor: pointer;\r\n\topacity: 0.5;\n}\nsvg[data-v-cb8fe668] { margin: -4px 4px 0 0; display: block\n}\r\n", ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
